
import ListComponent from "../../../components/mall_coupons/Index.vue";

export default {
  components: {
    ListComponent,
  },
};
